import { useMemo } from 'react'
import { Trans } from 'react-i18next'
import { v4 as uuid4 } from 'uuid'

import { DefaultVariableResult, VariableResultPageCover, VariableSelectFeatureFlag } from '@makyoapp/makyo-common'
import { Image16 } from '@makyoapp/makyo-icon/icon'

import { useAppPagesContext } from '@/context/AppPagesContext'

import { useVariableSelectContext } from './VariableSelectContext'

export default function VariableSelectPageCover() {
  const { id, setOpen, onChange, multiple, value } = useVariableSelectContext()
  const { activePage } = useAppPagesContext()
  const tempValue = useMemo<VariableResultPageCover>(
    () => ({
      id: uuid4(),
      flag: VariableSelectFeatureFlag.PageCover,
      value: activePage?.coverImage?.value || '',
    }),
    [activePage]
  )

  return (
    <button
      id={`${id}-page-cover`}
      className='gap-2 sdd-item'
      onClick={() => {
        onChange(multiple ? [...(value as DefaultVariableResult[]), tempValue] : tempValue)
        setOpen(false)
      }}
    >
      <Image16 />
      <div>
        <Trans>Page Cover</Trans>
      </div>
    </button>
  )
}
